import { TransformClasses_TransformClass_$ctor_Z207A3CFB, TransformClasses_TransformStyle_$ctor_Z207A3CFB, TransformClasses_TransformOrigin_$ctor_Z207A3CFB } from "../Types/Transform.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const TransformOrigin = TransformClasses_TransformOrigin_$ctor_Z207A3CFB(new Property_CssProperty(285));

export const TransformStyle = TransformClasses_TransformStyle_$ctor_Z207A3CFB(new Property_CssProperty(286));

export const Transform = TransformClasses_TransformClass_$ctor_Z207A3CFB(new Property_CssProperty(284));

